import React from 'react';
import '../style/Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return(
        <>
            <nav>
                <h2>ImagePicker</h2>
                <ul>
                    <Link class='link' to="/"><li>Home</li></Link>
                    <Link class='link' to="/images"><li>Images</li></Link>
                </ul>
            </nav>
        </>
    )
}

export default Navbar;